//@ts-ignore
import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useEffect } from "react";
import Meta from "../components/blocks/layout/Meta";
import { useUserContext } from "@/contexts/userContext";
import Loader from "@/components/Loader";
import BuildPage from "@/components/blocks/build/BuildPage";
import Layout from "@/components/blocks/layout/Layout";
import { useAppDetails } from "@/contexts/AppDetailsContext";

const Page: any = () => {
  const { user, userLoading } = useUserContext();
  const router = useRouter();
  const { t } = useTranslation("meta-details");
  const { details } = useAppDetails();
  useEffect(() => {
    if (typeof window !== "undefined")
      if (!user && !userLoading) {
        router.push({
          pathname: "/",
          query: {
            redirect: window.location.href,
            locale: router.query.locale || "en",
          },
        });
        return;
      }
  }, [user, userLoading]);

  if (!user && userLoading) {
    return (
      <div className="fixed   inset-0 flex justify-center items-center">
        <Loader text="Loading..." />
      </div>
    );
  }

  const main = () => (
    <>
      <div className={" mx-auto "}>
        <BuildPage />
      </div>
    </>
  );

  return (
    <Layout
      meta={
        <Meta
          title={details?.appName ?? ""}
          description={details?.brokerName}
        />
      }
    >
      {main()}
    </Layout>
  );
};
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "en", ["broker-page", 
        "build-page",
        "layout-page",
        "common-page",
        "test-page",
        "add-ons-form",
        "marketplace-page",
      ])),
    },
    // Update translations every 60 seconds (ISR)
  };
};
export default Page;
